/**
 * Parse env string to boolean. Only "true" (case-insensitive) is true.
 * @param {string | undefined} value
 * @param {boolean} [defaultValue=true]
 */
function envFlag(value, defaultValue = true) {
  if (value === undefined || value === '') return defaultValue;
  return value.toLowerCase() === 'true';
}

/** @type {const} */
export const FEATURES = {
  posting: envFlag(import.meta.env.VITE_FEATURE_POSTING),
  videos: envFlag(import.meta.env.VITE_FEATURE_VIDEOS),
  chat: envFlag(import.meta.env.VITE_FEATURE_CHAT),
  videoConference: envFlag(import.meta.env.VITE_FEATURE_VIDEO_CONFERENCE),
  manuals: envFlag(import.meta.env.VITE_FEATURE_MANUALS),
  courses: envFlag(import.meta.env.VITE_FEATURE_COURSES),
  yogiChatbot: envFlag(import.meta.env.VITE_FEATURE_YOGI_CHATBOT),
  meetings: envFlag(import.meta.env.VITE_FEATURE_MEETINGS),
  analytics: envFlag(import.meta.env.VITE_FEATURE_ANALYTICS),
  schedule: envFlag(import.meta.env.VITE_FEATURE_SCHEDULE),
  friends: envFlag(import.meta.env.VITE_FEATURE_FRIENDS),
  notifications: envFlag(import.meta.env.VITE_FEATURE_NOTIFICATIONS),
  social: {
    facebook: envFlag(import.meta.env.VITE_FEATURE_SOCIAL_FACEBOOK),
    instagram: envFlag(import.meta.env.VITE_FEATURE_SOCIAL_INSTAGRAM),
    linkedin: envFlag(import.meta.env.VITE_FEATURE_SOCIAL_LINKEDIN),
    twitter: envFlag(import.meta.env.VITE_FEATURE_SOCIAL_TWITTER),
    snapchat: envFlag(import.meta.env.VITE_FEATURE_SOCIAL_SNAPCHAT),
  },
  subscriptions: {
    feed: envFlag(import.meta.env.VITE_FEATURE_SUB_FEED, false),
    chat: envFlag(import.meta.env.VITE_FEATURE_SUB_CHAT, false),
    notifications: envFlag(import.meta.env.VITE_FEATURE_SUB_NOTIFICATIONS, false),
  },
};

/** @param {keyof typeof FEATURES} name */
export function isFeatureEnabled(name) {
  const val = FEATURES[name];
  if (typeof val === 'boolean') return val;
  return false;
}

/** @param {keyof typeof FEATURES.social} network */
export function isSocialEnabled(network) {
  return FEATURES.social[network] === true;
}
